export default function ({ value, max = 9, suffix = '+' }) {
  return value > max ? `${max}${suffix}` : value;
}
